import $ from "jquery"
import { Col, Table } from "react-bootstrap";
import { makeUniversalBlockKey, modelStore } from "../storage/model";
import { getFieldDef, reorderCurrentColumns } from "./Fields";
import { access, killContextMenuEventHandler, logTimestamp } from "../../support/general";
import { useEffect, useRef } from "react";
// import { draggingPostItPositionBlockId, draggingPostItSizeBlockId, onCancelPostItPositionDrag, onDragPostItPosition, onDragPostItSize, onEndPostItPositionDrag, onEndPostItSizeDrag } from "./EFolder";

// window.addEventListener(`contextmenu`, (e) => e.preventDefault());

export function TableColumn ({scriptId,subscriptId,content,label,debug}) {

    var tableWidth = 0;
    var headers = [];
    var dummyHeaders =[];
    var ref = useRef();

    // useEffect(()=>{
    //     ref.current.addEventListener(`contextmenu`, killContextMenuEventHandler);
    //     return (()=>{
    //         ref.current.removeEventListener(`contextmenu`, killContextMenuEventHandler);
    //     })
    // },[]);

    modelStore.useSelector(state=>{
        // called to create a redraw when field definitions are changed
        return access(state,["model","Script",scriptId,"subscripts",subscriptId,"customFields"]);
    },scriptId+"_"+subscriptId);

    var columns = modelStore.useSelector(state=>{
        return access(state,["model","Script",scriptId,"subscripts",subscriptId,"columns"]);
    },scriptId+"_"+subscriptId);

    //var columns = access(modelStore.state,["model","Script",scriptId,"subscripts",subscriptId,"columns"]);

    if (columns ) {

        logTimestamp("columns: " + subscriptId + " : " + columns.length);

        $.each(columns,(c,col)=>{

            var field = getFieldDef(modelStore.state,col.fieldId,subscriptId);            
            var colWidth = col.width?col.width:50;
            var colName = field?field.name:"";

            headers.push(ColumnHeader({colWidth,col,colName,handlers:{
                onStartHeadingDrag : (e)=>{onStartHeadingDrag(e,c)},
                onMouseDownOnHeader : (e)=>{onMouseDownOnHeader(e,subscriptId,c,colWidth,columns.length)}
            }}));

            dummyHeaders.push(ColumnHeader({colWidth,col,colName}));

            tableWidth += colWidth;
        
        })
    }

    return (<Col
        key = {label}
        id = "TableColumn"
        md="auto"
        ref = {ref}
        style = {{
            height : '100%',
            position : 'relative',
            width : tableWidth + 'px',
            padding : 0,
            border : 'solid 1px grey',
            borderRight : 'solid 5px lightgrey',
        }}
    >
        <div
            key=  "1"
            id = "ScrollWindow"
            className = 'noScrollBar'
            style ={{
                height : '100%',
                width : '100%',
                overflowY : 'auto',

            }}
        >
            <div
                id = "ScrollingContent"
                style = {{
                    width : tableWidth + 'px',
                    padding : '0px',
                    tableLayout: 'fixed',
                    borderTop:'solid 1px grey',
                    borderRight:'solid 1px grey',
                }}
                // className = {className}
            >
                <div id="DummyHeaders" key="1">
                    {dummyHeaders}
                </div>
                <div id ="content container" key="2">
                    {content}
                </div>
            </div>
        </div>
        <div 
            key=  "2"
            id = "headers"
            style = {{
                width : tableWidth + 'px',
                padding : 0,
                margin :0,
                position :'absolute',
                top : '0px',
                left : '0px',
                backgroundColor : 'white',
                            borderRight : 'solid 5px lightgrey',

            }}
        >
            {headers}
        </div>
        
    </Col>)
}


function ColumnHeader ({colWidth,col,colName,handlers}){

    var className = 'prevent-select '
    className = handlers?(className+' column-header'):className;
    var onStartHeadingDrag = handlers?handlers.onStartHeadingDrag:()=>{};
    var onMouseDownOnHeader = handlers?handlers.onMouseDownOnHeader:()=>{};

    return (<div 
        id = 'coldHeader'
        className = {className}
        style = {{
            width : colWidth+"px",
            maxWidth : colWidth+"px",
            margin : 0,
            padding : 0,
            // backgroundColor:'blue',
            borderBottom:'solid 1px grey',
            borderRight:'solid 1px grey',
            position : 'relative',
            display : 'table-cell',
            cursor : 'move',
            wordWrap : 'break-word',
        }}
        onMouseDown = {onStartHeadingDrag}
        key = {col.fieldId}
    >
        {colName}
        <div
            id = 'headerHandle'
            style ={{
                position : 'absolute',
                top :0,
                right :0,
                width : '0.5em',
                height : '100%',
                cursor : 'e-resize'
            }}
            onMouseDown = {onMouseDownOnHeader}
        >
            <div></div>
        </div>
    </div>)
}

export function Cell({id,col,onClick,children,style,className,onMouseOver,onMouseLeave}){

    function clickHandler(){
        if (onClick){
            onClick();
        }
    }
    style= $.extend({
            display : 'table-cell',
            padding : '0px',
            verticalAlign : 'top',
            borderBottom:'solid 1px grey',
            borderRight:'solid 1px grey',
            width : col.width+"px",
            maxWidth : col.width+"px",
            position : 'relative',
            cursor : onClick?'pointer':'default'
        } , style);

    return (<div
        id = {id?id:"Cell"}
        className= {className + " " + "p-0 m-0"}
        onClick = {clickHandler}
        key = {col.fieldId}
        style = {style}
        onMouseOver = {onMouseOver}
        onMouseLeave = {onMouseLeave}
    >
        {children}
    </div>)
}


var numColumns = 0;
var mouseDownAt = -1;
var colResizing = -1;
var resizingSubscriptId ;
var initialColWidth = -1;

export function onMouseDownOnHeader(e,subscriptId,colIndex,width,numColumns){
    numColumns = numColumns;
    e.stopPropagation();
    mouseDownAt = e.screenX;
    colResizing = colIndex;
    resizingSubscriptId = subscriptId;
    initialColWidth = width;
    // console.log("start col resize : " + colIndex)
}

var mouseMoveHandler=null;
var handlerDownAtX=0;
var handlerDownAtY=0;

export function setMouseMoveHandler(e,handler){
    
    mouseMoveHandler = $.extend({
            onUp : function(e,deltaX,deltaY){
                this.onMove(e,deltaX,deltaY);
            },
            cancel : function(e){

            }
    },handler);

    handlerDownAtX = e.screenX;
    handlerDownAtY = e.screenY;
}

export function onAppMouseMove(e){
    // console.log("onMove")
    if ( colResizing!=-1 && e.buttons==1){
        var newWidth = initialColWidth + (e.screenX - mouseDownAt);
        modelStore.dispatch(state=>{
            state.setActiveColumnsWidth (resizingSubscriptId,colResizing,newWidth);
            // console.log("col width = "+ newWidth)
        });
    } else if (draggingColIndex!=-1  && e.buttons==1){
        onColHeaderDrag(e)
    } else if ( draggingRow_BlockUid ){
        onRowDrag(e);
    // } else if (draggingPostItPositionBlockId!=-1){
    //     onDragPostItPosition(e)
    // } else if (draggingPostItSizeBlockId!=-1){
    //     onDragPostItSize(e)
    } else if (mouseMoveHandler){
        mouseMoveHandler.onMove(e,e.screenX-handlerDownAtX,e.screenY-handlerDownAtY)
    }
}
export function onColResizeMouseUp(e){
    if (colResizing!=-1){
        // console.log("End col resize")
    } else if (draggingColIndex!=-1 ){
        onColHeaderDragEnd(e)
    } else if (draggingRow_BlockUid){
        onRowDragDrop();
    // } else if (draggingPostItPositionBlockId!=-1){
    //     onCancelPostItPositionDrag(e)
    // } else if (draggingPostItSizeBlockId!=-1){
    //     onEndPostItSizeDrag(e)
    } else if (mouseMoveHandler){
        mouseMoveHandler.onUp(e,e.screenX-handlerDownAtX,e.screenY-handlerDownAtY);
        mouseMoveHandler.cancel(e)
        mouseMoveHandler = null;
    }
    colResizing = -1;
}

export function onColResizeMouseLeave(e){
    
    if (colResizing!=-1){
        // console.log("End col resize")
    } else if (draggingColIndex!=-1 ){
        onColHeaderDragEnd(e)
    } else if ( draggingRow_BlockUid ){
        cancelRowDrag();
    // } else if (draggingPostItPositionBlockId!=-1){
    //     onCancelPostItPositionDrag(e)
    // } else if (draggingPostItSizeBlockId!=-1){
    //     onEndPostItSizeDrag(e)
    } else if (mouseMoveHandler){
        mouseMoveHandler.cancel(e)
        mouseMoveHandler = null
    }
    colResizing = -1;
}


var draggingColIndex = -1;
var colHeaderScreenRects = [];
var $dragPositionIndicator = null;
var columnsHeaderDragOver = -1;

function onStartHeadingDrag(e,colIndex){
    e.stopPropagation();
    mouseDownAt = e.screenX;
    draggingColIndex = colIndex;

    var $headerElements = $('.column-header');

    colHeaderScreenRects = $headerElements.map ( (e,ele) => {
        var $ele = $(ele);
        var offset = $ele.offset();
        var width = $ele.width();
        var height = $ele.height();

        return {
            offset,
            width,
            height,
            left : offset.left,
            top : offset.top,
            right : offset.left + width,
            bottom : offset.top + height,
            centerX : offset.left + width/2,
            centerY : offset.top + height/2
        }
    });

    colHeaderScreenRects.sort((a, b) => a.left - b.left);

    var r = colHeaderScreenRects[colIndex];

    $dragPositionIndicator = $(`<div
        style = "
            display : block;
            position:absolute;
            opacity : 0.5;
            background-color : #CCFFCC;
            width : ${r.width}px;
            height : ${r.height}px;
            top : ${r.top}px;
            right ${r.left}px;
        "    
    >
        <div></div>
    </div>`);

    $('#App').append($dragPositionIndicator );

    positionColumnDragCursor(e);
}

function positionColumnDragCursor(e){
    var at = e.clientX;
    for (var c = 0;c<colHeaderScreenRects.length;c++){
        var r = colHeaderScreenRects[c];
        if (at<r.right ){
            break;
        }
    }

    c = (c<colHeaderScreenRects.length) ? c : (colHeaderScreenRects.length-1)
    var r= colHeaderScreenRects[c];

    $dragPositionIndicator.css({
        left : r.left,
        width : r.width,
    })

    columnsHeaderDragOver  = c;
}
function onColHeaderDrag(e){
    if (draggingColIndex>=0){
        positionColumnDragCursor(e);
    }

}

function onColHeaderDragEnd(){

    reorderCurrentColumns(draggingColIndex,columnsHeaderDragOver);
    draggingColIndex = -1;
    $dragPositionIndicator.remove();
    $dragPositionIndicator = null;

}

var mouseDownAtY = -1;
var draggingRow_BlockUid = null;
var rowScreenRects = [];
var onRowDrop;
var lastDragRowIndex = -1;
var lastRowOver = null;
var lastRowOverTop = false;

export function onStartRowDrag(e,blockUid,onDrop){

    if (!draggingRow_BlockUid){
        console.log ("Start row drag : " + blockUid);
        onRowDrop = onDrop;
        e.stopPropagation();
        mouseDownAtY = e.screenY;
        draggingRow_BlockUid = blockUid;

        var $rowElements = $('.column-row');
        var rowData = [];

        rowScreenRects = $rowElements.map ( (e,ele) => {
            var $ele = $(ele);
            var offset = $ele.offset();
            var width = $ele.width();
            var height = $ele.height();

            return {rect:{
                    offset,
                    width,
                    height,
                    left : offset.left,
                    top : offset.top,
                    right : offset.left + width,
                    bottom : offset.top + height,
                    centerX : offset.left + width/2,
                    centerY : offset.top + height/2
                },
                blockUid : $ele.data('block-uid'),
                isOpenSubdirectory :  $ele.data('is-open'),
            }
        });

        rowScreenRects.sort((a, b) => a.rect.top - b.rect.top);

        var r = rowScreenRects[0].rect;

        $dragPositionIndicator = $(`<div
            style = "
                display : block;
                position:absolute;
                opacity : 0.5;
                background-color : #CCFFCC;
                width : ${r.width}px;
                height : 10px;
                right ${r.left}px;
            "    
        >
            <div></div>
        </div>`);

        $('#App').append($dragPositionIndicator );

        positionRowDragCursor(e);

    }
}

function onRowDrag(e){
    positionRowDragCursor(e);
}

function cancelRowDrag(){
    $dragPositionIndicator.remove();
    draggingRow_BlockUid = null;
    onRowDrop = null;
}

function onRowDragDrop() {
    onRowDrop(lastRowOver,lastRowOverTop);
    cancelRowDrag();
}

function positionRowDragCursor(e){

    var at = e.clientY;
    var rr = -1;

    for (var c = rowScreenRects.length-1;c>=0;c--){
        var r = rowScreenRects[c].rect;
        if (r.centerY < at){
            rr=c;
            break;
        }
    }

    if ( rr < 0  ) {
        lastRowOver = rowScreenRects[0];
        var y = lastRowOver.rect.top;
        lastRowOverTop = true;
    } else {
        lastRowOver = rowScreenRects[rr];
        y = lastRowOver.rect.bottom;
        lastRowOverTop = false;
    }
 
    $dragPositionIndicator.css({
        top : (y-5)+'px'
    })

    columnsHeaderDragOver  = c;

}